import { isFieldError } from "../helpers";

import Input from "../components/Input";
import RadiosScale from "../components/RadiosScale";

export default function Q7Fields({ handleUpdate, errors }) {
	return (
		<>
			<h4 style={{ fontSize: "1.15rem" }}>
				7. Dashboard Experience (Optional but Valuable)
			</h4>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="7.1 How intuitive was the dashboard overall?"
					reqd={false}
					data={[
						{
							name: "q7_1",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q7_1",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q7_1",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q7_1",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q7_1",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q7_1") ? true : false}
				/>
			</div>

			<div className="form-group one " style={{ marginTop: "15px" }}>
				<Input
					name="q7_2"
					label="7.2 Which areas of the dashboard were the most challenging to use?"
					reqd={false}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>

			<div className="form-group one " style={{ marginTop: "15px" }}>
				<Input
					name="q7_3"
					label="7.3 Are there any features or tools you wish had been available?"
					reqd={false}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>
		</>
	);
}
